<link rel="ractive" href="../../r-page-globalping.html" name="r-page">
<link rel="ractive" href="../../components/gp-header.html" name="c-gp-header">
<link rel="ractive" href="../../components/gp-footer.html" name="c-gp-footer">
<link rel="ractive" href="../../components/notification.html" name="c-notification">
<link rel="ractive" href="../../components/gp-jumbotron.html" name="c-gp-jumbotron">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	<c-notification></c-notification>

	<c-gp-header additionalClasses="header-with-globalping-bg"></c-gp-header>

	<div class="p-globalping-slack">
		<c-gp-jumbotron className="slack" gridType="type2"></c-gp-jumbotron>

		<div class="gp-slack_main-info">
			<h1 class="gp-slack_main-info_title">
				With the <span class="gp-slack_green-text">Globalping App for Slack</span> all of your Slack members can run network commands such as ping, traceroute, mtr, http and DNS from a globally distributed network of probes.
			</h1>

			<div class="gp-slack_main-info_ctrls">
				<a target="_blank" rel="noopener noreferrer" href="https://bots.globalping.io/slack/install" class="gp-slack_main-info_ctrls_btn">
					<img width="139"
						height="40"
						src="{{@shared.assetsHost}}/img/globalping/gp-slack/slack-btn.svg">
				</a>

				<a href="mailto:d@jsdelivr.com" class="gp-slack_main-info_ctrls_btn gp_btn_black">
					<img width="20"
						height="20"
						src="{{@shared.assetsHost}}/img/globalping/gp-slack/mail-icon.svg">
					Contact us
				</a>
			</div>
		</div>

		<div class="gp-slack_content">
			<div class="gp-slack_content_header">
				<span>Globalping Integration for Slack Quick Start</span>
				<span>Simple to use, free and open source.</span>
			</div>

			<div class="gp-slack_content_steps">
				<div class="gp-slack_content_steps_item">
					<div class="gp-slack_content_steps_item_data">
						<span>1</span>
						<div>Install the app in your Slack organization</div>
						<div>Click to install bellow and select your Slack organization. After installation it will be available to all of your members.</div>
					</div>

					<img width="272"
						height="285"
						src="{{@shared.assetsHost}}/img/globalping/gp-slack/slack-screen-1.svg">
				</div>

				<div class="gp-slack_content_steps_item">
					<div class="gp-slack_content_steps_item_data">
						<span>2</span>
						<div>Trigger it by calling "/globalping"</div>
						<div>Any user can trigger a test by running the /globalping command. For example "/globalping ping jsdelivr.com from Germany".</div>
					</div>

					<img class="slack-screen-2"
						width="298"
						height="116"
						src="{{@shared.assetsHost}}/img/globalping/gp-slack/slack-screen-2.svg">
				</div>

				<div class="gp-slack_content_steps_item">
					<div class="gp-slack_content_steps_item_data">
						<span>3</span>
						<div>Use it to run commands and get results in any channel</div>
						<div>The results of the requested test will appear in the same channel or private message where it was triggered</div>
					</div>

					<img class="slack-screen-3"
						width="286"
						height="160"
						src="{{@shared.assetsHost}}/img/globalping/gp-slack/slack-screen-3.svg">
				</div>
			</div>

			<a target="_blank" rel="noopener noreferrer" href="https://bots.globalping.io/slack/install" class="gp-slack_content_btn">
				<img width="139"
					height="40"
					src="{{@shared.assetsHost}}/img/globalping/gp-slack/slack-btn.svg">
			</a>
		</div>
	</div>

	<c-gp-footer></c-gp-footer>
</r-page>

<script>
	component.exports = {
		data () {
			return {
				title: 'Globalping Slack App',
				description: 'A must have Slack App for devops and support teams, startups and corporations, that allows anyone to run global network tests in any channel and discuss the results.',
			};
		},
	};
</script>
